<!-- THIS IS A TEMPLATE TO COPY AND PASTE -->
<div style="width: 80vw; height: 90vh;" data-cy="pain-history-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="pain-history-header-section">
      <div class="section-header-title" data-cy="pain-history-title-text">
        Pain History
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1;overflow-y: hidden;" data-cy="pain-history-content-section">
      <app-pain-history data-cy="pain-history-component"></app-pain-history>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="pain-history-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="pain-history-ok-button">Ok</button>
    </div>
  </div>
</div>
